import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'
import i18n from 'i18n'

// ACTIONS
const gameRequested = createAction('game/requested')
const gameRequestFailed = createAction('game/requestFailed')
const gameReceived = createAction('game/received')
const gameClean = createAction('game/clean')

const gameChangeTurnRequested = createAction('game/changeTurnRequested')
const gameChangeTurnRequestFailed = createAction('game/changeTurnRequestFailed')
const gameChangeTurnReceived = createAction('game/changeTurnReceived')

const gameRetryGameRequested = createAction('game/retryGameRequested')
const gameRetryGameRequestFailed = createAction('game/retryGameRequestFailed')
const gameRetryGameReceived = createAction('game/retryGameReceived')

// REDUCER
export const initialState = {
  data: null,
  loading: false,
  changeTurnLoading: false,
  changeTurnSuccess: false,
  retryGameLoading: false,
  retryGameSuccess: false
}

const gameReducer = createReducer(initialState, {
  [gameRequested.type]: (state) => {
    state.loading = true
  },
  [gameReceived.type]: (state, action) => {
    state.loading = false
    state.data = action.payload
  },
  [gameRequestFailed.type]: (state) => {
    state.loading = false
  },
  [gameClean.type]: () => initialState,
  [gameChangeTurnRequested.type]: (state) => {
    state.changeTurnLoading = true
    state.changeTurnSuccess = false
  },
  [gameChangeTurnRequestFailed.type]: (state, action) => {
    state.changeTurnLoading = false
    toast.error(i18n.t(action.payload.message))
  },
  [gameChangeTurnReceived.type]: (state) => {
    state.changeTurnLoading = false
    state.changeTurnSuccess = true
  },
  [gameRetryGameRequested.type]: (state) => {
    state.retryGameLoading = true
    state.retryGameSuccess = false
  },
  [gameRetryGameRequestFailed.type]: (state, action) => {
    state.retryGameLoading = false
    toast.error(i18n.t(action.payload.message))
  },
  [gameRetryGameReceived.type]: (state) => {
    state.retryGameLoading = false
    state.retryGameSuccess = true
  }
})

export default gameReducer

// Public actions
export const loadUserGame = () =>
  apiCallBegan({
    url: `/user/game`,
    onStart: gameRequested.type,
    onSuccess: gameReceived.type,
    onError: gameRequestFailed.type
  })

export const cleanUserGame = () => (dispatch) => dispatch(gameClean())

export const changeTurn = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `games/${id}/turns/change`,
      method: 'post',
      onStart: gameChangeTurnRequested.type,
      onSuccess: gameChangeTurnReceived.type,
      onError: gameChangeTurnRequestFailed.type
    })
  )
}

export const retryGame = ({ difficulty, payload }) =>
  apiCallBegan({
    url: `game_set/retry_game`,
    method: 'post',
    data: payload,
    onStart: gameRetryGameRequested.type,
    onSuccess: gameRetryGameReceived.type,
    onError: gameRetryGameRequestFailed.type
  })